import { render } from "./ConfirmationPage.vue?vue&type=template&id=56dbe7ba"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.31_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__